module.exports = (Promise.resolve(__parcel__require__("./" + "Doppio.6c0d70f2.5658e278.js"))).then(() => parcelRequire('8hkMG'));